import { render } from "./HistoricalReview.vue?vue&type=template&id=f3326e3a"
import script from "./HistoricalReview.vue?vue&type=script&lang=js"
export * from "./HistoricalReview.vue?vue&type=script&lang=js"

import "./HistoricalReview.vue?vue&type=style&index=0&id=f3326e3a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__